import { css } from '@emotion/core';
import styled from '@emotion/styled';
import { SM_SCREEN_MAX } from '../../../../modules/Styleguide';

export const DesktopWrapper = styled.div`
  display: flex;
  max-width: 840px;
  margin: auto;
  @media (max-width: 768px) {
    display: none;
  }
`;

export const MobileWrapper = styled.div`
  display: none;
  @media (max-width: 768px) {
    display: block;
  }
`;

export const CarouselGlobalStyles = css`
  .carousel {
    height: 210px;
  }
  .carousel-indicators li {
    width: 8px !important;
    height: 8px !important;
    margin: 0 4px;
    background-color: #000;
    opacity: 0.2;
    border: 0;
  }
  .carousel-indicators li.active {
    background-color: #5000b9;
    opacity: 1;
    border: 0;
    margin: 0 4px;
  }
  .carousel-control {
    background-image: none !important;
    opacity: 1;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const ValuePropositionContainer = styled.div`
  text-align: center;
  flex: 1;
  padding: 0 16px;
  @media (max-width: ${SM_SCREEN_MAX}px) {
    max-width: 276px;
    margin: auto;
  }
`;

export const IconWrapper = styled.div`
  height: 64px;
  width: 64px;
  background-color: #5000b9;
  border-radius: 100%;
  padding: 14px;
  margin: auto;
  margin-bottom: 24px;
`;

export const Header = styled.h4`
  font-size: 1.6rem;
  margin-bottom: 8px;
`;

export const Copy = styled.p`
  font-size: 1.3rem;
`;
